import React from 'react';

import cn from 'classnames';
import moment from 'moment';

import { IFinanceExportReport } from '@entities/financeExportReport';
import { DateHelpers } from '@shared/helpers';
import { UiText } from '@shared/ui';

import cls from './ReportRow.module.css';
import { ReportActions } from '../ReportActions/ReportActions';
import { ReportStatusIcon } from '../ReportStatusIcon/ReportStatusIcon';

interface ReportRowProps {
    report: IFinanceExportReport;
    onDelete: (id: number) => void;
    onRetry: (id: number) => void;
    onDownload: (fileUrl: string) => void;
    classes?: string;
}

export const ReportRow = ({ report, onDelete, onRetry, onDownload, classes }: ReportRowProps) => (
    <tr className={cn(cls.row, classes)}>
        <td className={cls.status}>
            <ReportStatusIcon status={report.status} />
        </td>
        <td className={cls.cell}>
            <UiText>{report.reportType.label}</UiText>
        </td>
        <td className={cls.cell}>
            <UiText className={cls.objectName}>{report.filters.project || '—'}</UiText>
        </td>
        <td className={cls.params}>
            {report?.filters?.params?.map((param, i) => (
                <p key={i}>
                    <UiText tag="span" className={cls.parameters}>
                        {param.label}
                    </UiText>
                    :{' '}
                    <UiText tag="span" className={cls.parameters}>
                        {param.value}
                    </UiText>
                </p>
            ))}
        </td>
        <td className={cls.cell}>
            {report?.filters?.period ? (
                <>
                    <UiText tag="span">
                        {DateHelpers.dateFormatter({ date: report.filters.period.startDate })}
                    </UiText>{' '}
                    -{' '}
                    <UiText tag="span">
                        {DateHelpers.dateFormatter({ date: report.filters.period.endDate })}
                    </UiText>
                </>
            ) : (
                '—'
            )}
        </td>
        <td className={cls.cell}>
            <UiText>{DateHelpers.dateFormatter({ date: report.createdAt })}</UiText>
        </td>
        <td className={cls.cellActions}>
            <ReportActions
                report={report}
                onDelete={onDelete}
                onRetry={onRetry}
                onDownload={onDownload}
            />
        </td>
    </tr>
);
